import type { ReactNode } from 'react';

export const symbol_contact_emergency: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M60-120q-24 0-42-18T0-180v-600q0-24 18-42t42-18h840q24 0 42 18t18 42v600q0 24-18 42t-42 18H60Zm531-60h309v-600H60v600h7q44-69 112.5-109T329-329q81 0 149.5 40T591-180ZM414-435q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35ZM143-180h372q-36-42-84.5-65.5T329-269q-53 0-101.5 23.5T143-180Zm143-297q-17-17-17-43t17-43q17-17 43-17t43 17q17 17 17 43t-17 43q-17 17-43 17t-43-17Zm194-3Zm220-85v55q0 8 6 14t14 6q8 0 14-6t6-14v-55l48 27q7 4 14.5 2.5T815-545q5-7 2.5-14.5T808-572l-48-28 48-28q7-4 9.5-11.5T815-655q-4-7-12-9t-15 2l-48 27v-55q0-8-6-14t-14-6q-8 0-14 6t-6 14v55l-48-27q-7-4-14.5-2.5T625-655q-5 7-2.5 14.5T632-628l48 28-48 28q-7 4-9.5 11.5T625-545q4 7 12 9t15-2l48-27Z"
		/>
	</svg>
);
